import React from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';

export const SubmitterName = () => {
  return (
    <React.Fragment>
      <TextInput
        label="Full name"
        id="submitter-full-name"
        model="attestation.submitterName"
        type="text"
        formatter={(value) => {
          return value.replace(/[!@#$%^&*)({}<>,.[\]+_`~=\\|';":/?0-9]/g, '');
        }}
        validators={{
          required: 'Full name is required.',
          invalid: {
            value: (value) => {
              return !value.match(/[[a-zA-Z\]]/g) || value.length < 2;
            },
            message: 'Please enter a valid Full name.',
          },
        }}
        data-testid="attestation-submitter-full-name"
        maxLength={40}
        name={`submitter-name-input-${uniqueId()}`}
        autoComplete="none"
      />
    </React.Fragment>
  );
};

SubmitterName.propTypes = {};

SubmitterName.defaultProps = {};
